// src/components/ModulePlaceholder.js
// 尚未开发的模块统一占位页（依据当前路由从信息架构配置中取名称与描述）
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ToolOutlined } from '@ant-design/icons';
import { findMenu, pick } from '../config/menuConfig';

const ModulePlaceholder = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const meta = findMenu(location.pathname);
  const title = meta ? pick(meta.label, lang) : '模块建设中';
  const desc = meta ? pick(meta.desc, lang) : '该模块正在规划中。';
  const section = meta ? pick(meta.sectionLabel, lang) : '';

  return (
    <div className="module-placeholder">
      <div className="module-placeholder-icon">
        <ToolOutlined />
      </div>
      {section ? <div className="module-placeholder-section">{section}</div> : null}
      <div className="module-placeholder-title">{title}</div>
      <div className="module-placeholder-desc">{desc}</div>
      <div className="module-placeholder-tag">改版原型预览 · 待接入数据</div>
    </div>
  );
};

export default ModulePlaceholder;